import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const HeroArticleWrapper = styled.div`
  display: block;
  width: 750px;
  height: 392px;
  background-color: #ffffff;

  &:hover #hero-article-title {
    text-decoration: underline;
  }

  @media (${mediaQuery.tablet}) {
    width: 100%;
    height: 402px;
    margin-bottom: 32px;
  }

  @media (${mediaQuery.mobile}) {
    width: 100%;
    padding: 0;
    height: 250px;
  }
`;

export const HeroArticleImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000000;
  overflow: hidden;
  border-radius: 3px;
  @media (${mediaQuery.tablet}) {
    border-radius: 0px;
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    background-color: #f4f4f4;
  }

  .play-icon-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    span {
      height: 50px;
      width: 50px;
    }

    @media (${mediaQuery.mobile}) {
      svg {
        width: 69px;
        height: 69px;
      }
    }
  }
`;

export const ImageOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(#fff0, #0000001f, #000000);
`;

export const HeroArticleCaption = styled.div`
  position: absolute;
  padding: 16px 34px 16px 16px;
  @media (${mediaQuery.mobile}) {
    padding: 16px 16px 14px 16px;
  }
  bottom: 0;
  width: 100%;
  color: #ffffff;
`;

export const HeroArticleMeta = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: normal;
`;

export const HeroArticleCategory = styled.div`
  margin-bottom: 8px;
  width: 242px;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 14px;
  font-weight: 300;
  color: #ffffff;
  @media (${mediaQuery.tablet}) {
    margin-bottom: 8px;
  }
  @media (${mediaQuery.mobile}) {
    margin-bottom: 4px;
    font-size: 12px;
    line-height: 12px;
  }
`;

export const HeroArticleTitle = styled.h2`
  --lh: 26px;
  --max-lines: 2;
  margin-bottom: 16px;
  word-break: break-word;
  width: 100%;
  font-size: 20px;
  color: #ffffff;
  line-height: var(--lh);
  height: calc(var(--lh) * var(--max-lines));
  font-weight: 400;
  letter-spacing: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--max-lines);
  overflow: hidden;
  @media (${mediaQuery.tablet}) {
    overflow: hidden;
    margin-bottom: 16px;
  }
  @media (${mediaQuery.mobile}) {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 8px;
    height: 44px;
  }
`;

export const Author = styled.div`
  margin: 0;
  font-size: 14px;
  @media (${mediaQuery.tablet}) {
    font-size: 12px;
  }
  @media (${mediaQuery.mobile}) {
    font-size: 12px;
  }
  line-height: 20px;
  letter-spacing: normal;
  color: #ffffff;
`;

export const AuthorName = styled.div`
  color: #ffffff;
  text-transform: capitalize;
  font-weight: 400;
  &:hover {
    text-decoration: none;
    color: #ffffff;
  }
`;
